module.exports = __webpack_public_path__ + "assets/img/03514e1f8dfa670f2bbd8f40f59a9542.png";